import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from '@tanstack/react-query';
import { i18nInitPromise } from './i18n';
import App from "./App";
import { queryClient } from './queryClient';

// Wait for i18next to finish initialising (language detection + fallback
// resolution) before mounting the app. 
void i18nInitPromise.catch(() => undefined).finally(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </React.StrictMode>
  );
});

// Export for pilet consumption
export { usePermissions } from "./hooks/usePermissions";
export { useAuth } from "./contexts/AuthContext";
export { apiService } from "./services/apiService";
export { permissionService } from "./services/permissionService";

// Export types
export type {
  ApiRole,
  ApiResource,
  ApiAction,
  ApiPermission,
  ApiRolePermissions,
  User,
  PiletPermissionService,
  PiletApiService,
  PiletAuthContext,
} from "./types";

export type {
  ModuleId,
  ModuleAction,
  PermissionAction,
} from "./services/permissionService";
